module.exports = __webpack_public_path__ + "AEON INSURANCE BROKERS.2Csvg.png";